module.exports = __webpack_public_path__ + "img/88.e6bb714c.jpg";